export default __webpack_public_path__ + "static/media/home-12.6b31694d.jpg";